module.exports = __webpack_public_path__ + "static/media/3DPPA14.8f27f3cb.jpg";